<script setup lang="ts">
  import { onMounted, onBeforeUnmount, watch } from 'vue';
  import { storeToRefs } from 'pinia';
  import { ModalsContainer } from 'vue-final-modal';
  import { RouterView } from 'vue-router';
  import { ThemeProvider } from '@/shared/ui/theme-provider';
  import { useAppColorMode } from '@/shared/lib/use';
  import { useAuthStore } from '@/entities/Session';
  import { useRealtimeNotices } from '@/entities/ReminderHistory';

  // Layouts without the header toggle (the form builder, login) still need the mode applied.
  useAppColorMode();

  const authStore = useAuthStore();
  const { isAuthenticated, selectedBranchId } = storeToRefs(authStore);
  const { connect, disconnect } = useRealtimeNotices();

  onMounted(() => {
    if (isAuthenticated.value) {
      connect();
    }
  });

  watch(isAuthenticated, (authenticated) => {
    if (authenticated) {
      connect();
    } else {
      disconnect();
    }
  });

  watch(selectedBranchId, (newBranchId, previousBranchId) => {
    if (!isAuthenticated.value || newBranchId === previousBranchId) {
      return;
    }

    disconnect();
    connect();
  });

  onBeforeUnmount(() => {
    disconnect();
  });
</script>

<template>
  <div>
    <ThemeProvider>
      <RouterView />
      <ModalsContainer />
    </ThemeProvider>
  </div>
</template>

<style scoped></style>
